module.exports = __webpack_public_path__ + "static/12-159d190ebbe0b2542355abb1eb94d4b4.png";